import Layout from "../../components/user/Layout";
import "../../styles/PlaceOrder.css";
import { useEffect } from "react";
import confetti from "canvas-confetti";

function PlaceOrder() {
    useEffect(() => {
        const duration = 3 * 1000;
        const animationEnd = Date.now() + duration;

        const interval = setInterval(() => {
            const timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
                return clearInterval(interval);
            }

            confetti({
                particleCount: 100,
                angle: 60,
                spread: 55,
                origin: { x: 0 },
            });
            confetti({
                particleCount: 100,
                angle: 120,
                spread: 55,
                origin: { x: 1 },
            });
        }, 250);
    }, []);

    return (
        <Layout>
            <div className="order-success-container" style={{ textAlign: "center", marginTop: "100px" }}>
                <h2 className="success-message">
                    🎉 Your order has been placed successfully! 🎉
                </h2>
            </div>
        </Layout>
    );
}

export default PlaceOrder;